'use client';

import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Illustration from './Illustrations';
import Reveal from './Reveal';
import { BrowserFrame, PhoneFrame, Shot } from './Shot';

/**
 * One module: copy on one side; on the other, the desktop screen with the same screen
 * on a phone overlapping its corner. Modules with several screens get tabs that switch both.
 */
export default function ModuleShowcase({ module: m, index }) {
  const [active, setActive] = useState(0);
  const tabbed = m.shots.length > 1;
  const reverse = index % 2 === 1;
  const current = m.shots[active];

  return (
    <section id={m.id} className={`module${reverse ? ' reverse' : ''}`} style={{ '--accent': m.accent, '--accent-soft': `${m.accent}1a`, '--accent-line': `${m.accent}40` }}>
      <Reveal className="module-copy">
        <span className="eyebrow accent">{m.tag}</span>
        <h3>{m.title}</h3>
        <p className="lead">{m.text}</p>
        <ul className="ticks">
          {m.points.map((p) => (
            <li key={p}><span className="tick"><FontAwesomeIcon icon={faCheck} /></span>{p}</li>
          ))}
        </ul>
      </Reveal>

      <Reveal className="module-visual" delay={120}>
        <div className="glow" aria-hidden="true" />
        <div className="module-art" aria-hidden="true"><Illustration name={m.illustration} accent={m.accent} /></div>

        {tabbed && (
          <div className="shot-tabs" role="tablist" aria-label={`${m.tag} screens`}>
            {m.shots.map((s, i) => (
              <button key={s.key} role="tab" aria-selected={i === active} className={i === active ? 'is-active' : ''} onClick={() => setActive(i)}>{s.label}</button>
            ))}
          </div>
        )}

        <BrowserFrame url={current.url}>
          <div className="tour-stack">
            {m.shots.map((s, i) => (
              <div key={s.key} className={`tour-slide${i === active ? ' is-active' : ''}`} aria-hidden={i !== active}>
                <Shot name={s.key} alt={i === active ? `${m.tag}${s.label ? `: ${s.label}` : ''} on desktop` : ''} />
              </div>
            ))}
          </div>
        </BrowserFrame>

        <div className="module-phone">
          <PhoneFrame>
            <div className="phone-stack">
              {m.shots.map((s, i) => (
                <div key={s.key} className={`phone-slide${i === active ? ' is-active' : ''}`} aria-hidden={i !== active}>
                  <Shot name={s.phone} alt={i === active ? `${m.tag}${s.label ? `: ${s.label}` : ''} on a phone` : ''} />
                </div>
              ))}
            </div>
          </PhoneFrame>
        </div>

      </Reveal>
    </section>
  );
}
